module.exports = __webpack_public_path__ + "img/step-connect.6e96e3fc.svg";